import { render, staticRenderFns } from "./skill-tree.component.vue?vue&type=template&id=44dbf63c&scoped=true&"
import script from "./skill-tree.component.vue?vue&type=script&lang=ts&"
export * from "./skill-tree.component.vue?vue&type=script&lang=ts&"
import style0 from "./skill-tree.component.vue?vue&type=style&index=0&id=44dbf63c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dbf63c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VProgressCircular,VRow,VTextField})
